import { Component, isDevMode, OnInit } from '@angular/core';
import { AppConfig } from './app.config';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'AfricaWeather';

  constructor(
    private readonly appConfig: AppConfig,
    private readonly router: Router
  ) {
    this.appConfig.setValues();
  }

  ngOnInit(): void {
    if (!isDevMode()) {
      this.router.events
        .pipe(
          filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
        )
        .subscribe((event: NavigationEnd) => {
          gtag('config', 'G-BS3UFUM38N', {
            page_path: event.urlAfterRedirects
          });
        });
    }
  }
}
